module.exports = __webpack_public_path__ + "static/media/Coin_Toss.037752b5.png";